/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_02b12b2b{display:inline-block;vertical-align:middle;speak:none;width:1em;height:1em}.svg_02b12b2b{height:100%;fill:currentColor;vertical-align:top}"}]);
export const root = "root_02b12b2b";
export const svg = "svg_02b12b2b";